import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import apiStore from './store/apiStore';
import { Provider } from 'react-redux';
import App from './app';
import './main.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <Provider store={apiStore}>
      <App />
    </Provider>
  </BrowserRouter>,
);
